unit unit_TicketNeu;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Grids, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, DB, WEBLib.WebCtrls;

type
  TTicketNeu = class(TForm)
    xdsKontosaldo: TXDataWebDataSet;
    TC: TTableControl;
    xdsTicket: TXDataWebDataSet;
    xdsKontosaldoKundennummer: TStringField;
    xdsKontosaldoZeitaufwand: TIntegerField;
    xdsKontosaldoAbzurechnen: TIntegerField;
    xdsKontosaldoGutschrift: TIntegerField;
    xdsKontosaldoAbzug: TIntegerField;
    xdsKontosaldoSaldo: TIntegerField;
    xdsKontosaldoBetrag: TFloatField;
    xdsKontosaldoMinutenpreis: TFloatField;
    xdsKontosaldoSRestguthaben: TIntegerField;
    xdsTicketKundennummer: TXDataWebEntityField;
    xdsTicketProdukt: TXDataWebEntityField;
    xdsTicketKategorie: TXDataWebEntityField;
    xdsTicketPrioritaet: TXDataWebEntityField;
    xdsTicketStatus: TXDataWebEntityField;
    xdsTicketID: TIntegerField;
    xdsTicketErstelltAm: TDateTimeField;
    xdsTicketBetreff: TStringField;
    xdsTicketBeschreibung: TStringField;
    xdsTicketAbrechnungsbetrag: TFloatField;
    xdsTicketAbrechnungRechnungsnummer: TStringField;
    xdsTicketAberechnetAm: TDateTimeField;
    xdsTicketErledigtAm: TDateTimeField;
    xdsTicketNachname: TStringField;
    xdsTicketVorname: TStringField;
    xdsTicketEmail: TStringField;
    xdsTicketSystemInfo: TStringField;
    xdsTicketLoesung: TStringField;
    xdsTicketProtokoll: TStringField;
    xdsTicketZeitaufwandMinuten: TIntegerField;
    xdsTicketAbzurechnendeMinuten: TIntegerField;
    xdsTicketAbgerechneteMinuten: TIntegerField;
    xdsTicketBenachrichtigungNEU: TDateTimeField;
    xdsTicketBenachrichtigungLoesung: TDateTimeField;
    xdsTicketInterneBemerkung: TStringField;
    xdsTicketLoesungInfoSenden: TIntegerField;
    xdsTicketKontaktperson: TStringField;
    xdsTicketErreichbarkeitTelefon: TStringField;
    xdsTicketErreichbarkeitWann: TStringField;
    xdsProdukte: TXDataWebDataSet;
    xdsProdukteProdukt: TStringField;
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenGruppeKunden: TBooleanField;
    xdsKundendatenGruppeLieferanten: TBooleanField;
    xdsKundendatenGruppeSonstige: TBooleanField;
    xdsKundendatenGruppeNichtkunden: TBooleanField;
    xdsKundendatenKontaktgruppe: TStringField;
    xdsKundendatenNachname: TStringField;
    xdsKundendatenVorname: TStringField;
    xdsKundendatenAdresszeile2: TStringField;
    xdsKundendatenAdresszeile3: TStringField;
    xdsKundendatenStrasse: TStringField;
    xdsKundendatenPostleitzahl: TStringField;
    xdsKundendatenOrt: TStringField;
    xdsKundendatenLaenderkuerzel: TStringField;
    xdsKundendatenLand: TStringField;
    xdsKundendatenLaenderkennzeichen: TBooleanField;
    xdsKundendatenAdressanrede: TStringField;
    xdsKundendatenBriefanrede1: TStringField;
    xdsKundendatenAdresseBild: TStringField;
    xdsKundendatenLieferanschrift: TStringField;
    xdsKundendatenTelefonNummer: TStringField;
    xdsKundendatenTelefaxNummer: TStringField;
    xdsKundendatenMobilTelefon: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenInternet: TStringField;
    xdsKundendatenUmsatzsteuerID: TStringField;
    xdsKundendatenUmsatzsteuerausweis: TBooleanField;
    xdsKundendatenZahlungsbedingung: TIntegerField;
    xdsKundendatenTransportbedingung: TStringField;
    xdsKundendatenKeinNewsletter: TBooleanField;
    xdsKundendatenTelefonAlternativ: TStringField;
    xdsKundendatenTitel: TStringField;
    xdsKundendatenKundenklasseFarbe: TIntegerField;
    xdsKundendatenRechnungEmail: TStringField;
    xdsKundendatenLoginPW: TStringField;
    xdsKundendatenBesteuerungKey: TIntegerField;
    xdsKundendatenAuftraegeJahr: TFloatField;
    xdsKundendatenAuftraegeVorjahr: TFloatField;
    xdsKundendatenLieferadresseID: TIntegerField;
    xdsKundendatenUSTIDgeprueft: TDateTimeField;
    xdsKundendatenKontaktverbund: TStringField;
    xdsKundendatenHinweis: TStringField;
    xdsKundendatenLatitude: TFloatField;
    xdsKundendatenLongitude: TFloatField;
    xdsKundendatenkmLuftlinie: TFloatField;
    xdsKundendatenGoogleID: TStringField;
    xdsKundendatenGoogleUpdatedUTC: TDateTimeField;
    xdsKundendatenBundesland: TStringField;
    xdsKundendatenRegion: TStringField;
    xdsKundendatenMandatsreferenz: TStringField;
    xdsKundendatenMandatsreferenzVom: TDateTimeField;
    xdsKundendatenLastschriftArt: TStringField;
    xdsKundendatenMahnsperre: TBooleanField;
    xdsKundendatenSuchbegriff: TStringField;
    xdsKundendatenLieferanschriftDaten: TStringField;
    xdsKundendatenExportKasse: TBooleanField;
    xdsKundendatenLoeschvormerkungDatum: TDateTimeField;
    xdsKundendatenLoeschvormerkungGrund: TStringField;
    xdsKundendatenPseudonymisiert: TStringField;
    xdsKundendatenLoginAktiv: TIntegerField;
    xdsKundendatenSonstigeDaten: TStringField;
    xdsStatus: TXDataWebDataSet;
    xdsStatusStatus: TStringField;
    xdsKategorie: TXDataWebDataSet;
    xdsKategorieKategorie: TStringField;
    xdsprioritaet: TXDataWebDataSet;
    xdsprioritaetPrioritaet: TIntegerField;
    xdsprioritaetPrioText: TStringField;
    xdsprioritaetPrioFarbe: TIntegerField;
    xdsTicketDateien: TXDataWebDataSet;
    xdsTicketDateienTicketID: TXDataWebEntityField;
    xdsTicketDateienID: TIntegerField;
    xdsTicketDateienDatumUhrzeit: TDateTimeField;
    xdsTicketDateienFuerLoesung: TIntegerField;
    xdsTicketDateienDateiMime: TStringField;
    xdsTicketDateienDateiName: TStringField;
    xdsTicketDateienDateiGroesse: TIntegerField;
    xdsTicketDateienDateiInhaltText: TStringField;
    WebFilePicker1: TFilePicker;
    WebFilePicker2: TFilePicker;
    WebFilePicker3: TFilePicker;
    xdsticket2: TXDataWebDataSet;
    xdsTicketKontaktpersonEmail: TStringField;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    PanelTop: TPanel;
    lblSeite: TLabel;
    panelfunctions: TPanel;
    btnzurueck: TButton;
    xdsticket2Kundennummer: TXDataWebEntityField;
    xdsticket2Produkt: TXDataWebEntityField;
    xdsticket2Kategorie: TXDataWebEntityField;
    xdsticket2Prioritaet: TXDataWebEntityField;
    xdsticket2Status: TXDataWebEntityField;
    xdsticket2ID: TIntegerField;
    xdsticket2ErstelltAm: TDateTimeField;
    xdsticket2Betreff: TStringField;
    xdsticket2Beschreibung: TStringField;
    xdsticket2Abrechnungsbetrag: TFloatField;
    xdsticket2AbrechnungRechnungsnummer: TStringField;
    xdsticket2AberechnetAm: TDateTimeField;
    xdsticket2ErledigtAm: TDateTimeField;
    xdsticket2Nachname: TStringField;
    xdsticket2Vorname: TStringField;
    xdsticket2Email: TStringField;
    xdsticket2SystemInfo: TStringField;
    xdsticket2Loesung: TStringField;
    xdsticket2Protokoll: TStringField;
    xdsticket2ZeitaufwandMinuten: TIntegerField;
    xdsticket2AbzurechnendeMinuten: TIntegerField;
    xdsticket2AbgerechneteMinuten: TIntegerField;
    xdsticket2BenachrichtigungNEU: TDateTimeField;
    xdsticket2BenachrichtigungLoesung: TDateTimeField;
    xdsticket2InterneBemerkung: TStringField;
    xdsticket2LoesungInfoSenden: TIntegerField;
    xdsticket2Kontaktperson: TStringField;
    xdsticket2KontaktpersonEmail: TStringField;
    xdsticket2ErreichbarkeitTelefon: TStringField;
    xdsticket2ErreichbarkeitWann: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsKontosaldoAfterOpen(DataSet: TDataSet);
    procedure xdsProdukteAfterOpen(DataSet: TDataSet);
    procedure xdsTicketAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure xdsTicketAfterPost(DataSet: TDataSet);
    procedure xdsTicketAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsStatusAfterOpen(DataSet: TDataSet);
    procedure xdsKategorieAfterOpen(DataSet: TDataSet);
    procedure xdsprioritaetAfterOpen(DataSet: TDataSet);
    procedure xdsTicketDateienNewRecord(DataSet: TDataSet);
    procedure WebFilePicker1Change(Sender: TObject);
    procedure xdsticket2AfterOpen(DataSet: TDataSet);
    procedure WebFilePicker1GetFileAsBase64(Sender: TObject;
      AFileIndex: Integer; ABase64: string);
    procedure WebFilePicker2Change(Sender: TObject);
    procedure WebFilePicker3Change(Sender: TObject);
    procedure WebFilePicker2GetFileAsBase64(Sender: TObject;
      AFileIndex: Integer; ABase64: string);
    procedure WebFilePicker3GetFileAsBase64(Sender: TObject;
      AFileIndex: Integer; ABase64: string);
    procedure xdsTicketDateienAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsTicketDateienAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    TicketNeuFuerKundennummer:string;
    TicketNeuBetreff:string;
    TicketNeuText:string;
    NewTicketNumber:string;
    btnAbsenden:TButton;
    procedure btnAbsendenclick(Sender:TObject);
    procedure Formularaktualisieren;
    procedure uploadfilepickers;
  protected procedure LoadDFMValues; override; end;

var
  TicketNeu: TTicketNeu;
  edtTicketGrund:TComboBox;
  edtBetreff:TEdit;
  edtBeschreibung:TMemo;
  edtKontaktperson:TEdit;
  edtKontaktpersonEmail:TEdit;
  edtTelefon:TEdit;
  edtWann:TEdit;
  edtSystemInfo:TMemo;
  file1base64str1:string;
  file1base64str2:string;
  file1base64str3:string;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TTicketNeu.uploadfilepickers;
var
  hasnewrecord:boolean;
begin
  hasnewrecord:=false;
  if file1base64str1<>'' then
  begin
    xdsTicketDateien.Append();
    xdsTicketDateienTicketID.Value:=xdsticket2.CurrentData;
    xdsTicketDateienDatumUhrzeit.AsDateTime:=Date+time;
    xdsTicketDateienFuerLoesung.AsInteger:=0;
    xdsTicketDateienDateiMime.AsString:=WebFilePicker1.Files.Items[0].MimeType;
    xdsTicketDateienDateiGroesse.AsInteger:=WebFilePicker1.Files.Items[0].Size;
    xdsTicketDateienDateiName.AsString:=WebFilePicker1.Files.Items[0].Name;
    xdsTicketDateienDateiInhaltText.AsString:=file1base64str1;
    xdsTicketDateien.Post();
    hasnewrecord:=true;
  end;
  if file1base64str2<>'' then
  begin
    xdsTicketDateien.Append();
    xdsTicketDateienTicketID.Value:=xdsticket2.CurrentData;
    xdsTicketDateienDatumUhrzeit.AsDateTime:=Date+time;
    xdsTicketDateienFuerLoesung.AsInteger:=0;
    xdsTicketDateienDateiMime.AsString:=WebFilePicker2.Files.Items[0].MimeType;
    xdsTicketDateienDateiGroesse.AsInteger:=WebFilePicker2.Files.Items[0].Size;
    xdsTicketDateienDateiName.AsString:=WebFilePicker2.Files.Items[0].Name;
    xdsTicketDateienDateiInhaltText.AsString:=file1base64str2;
    xdsTicketDateien.Post();
    hasnewrecord:=true;
  end;
  if file1base64str3<>'' then
  begin
    xdsTicketDateien.Append();
    xdsTicketDateienTicketID.Value:=xdsticket2.CurrentData;
    xdsTicketDateienDatumUhrzeit.AsDateTime:=Date+time;
    xdsTicketDateienFuerLoesung.AsInteger:=0;
    xdsTicketDateienDateiMime.AsString:=WebFilePicker3.Files.Items[0].MimeType;
    xdsTicketDateienDateiGroesse.AsInteger:=WebFilePicker3.Files.Items[0].Size;
    xdsTicketDateienDateiName.AsString:=WebFilePicker3.Files.Items[0].Name;
    xdsTicketDateienDateiInhaltText.AsString:=file1base64str3;
    xdsTicketDateien.Post();
    hasnewrecord:=true;
  end;
  if hasnewrecord=true then
  begin
    xdsticketdateien.ApplyUpdates;
  end
  else
  begin
    showmessage('Das Ticket wurde erfolgreich erstellt.');
    close;
  end;
end;

procedure TTicketNeu.btnzurueckClick(Sender: TObject);
begin
  close;
end;

procedure TTicketNeu.btnAbsendenClick(Sender: TObject);
begin
  if edtBetreff.Text='' then
  begin
    showmessage('Sie müssen einen Betreff eingeben');
    exit;
  end;
  if edtBeschreibung.Text='' then
  begin
    showmessage('Sie müssen eine Beschreibung eingeben');
    exit;
  end;
  if edtKontaktperson.Text='' then
  begin
    showmessage('Sie müssen eine Kontaktperson eingeben');
    exit;
  end;
  if edtTelefon.Text='' then
  begin
    showmessage('Sie müssen eine Telefonnummer eingeben');
    exit;
  end;
  if edtWann.Text='' then
  begin
    showmessage('Sie müssen die Erreichbarkeit eingeben');
    exit;
  end;
  if edtTicketGrund.Text='' then
  begin
    showmessage('Sie müssen einen Grund/Produkt auswählen');
    exit;
  end;

  if edtKontaktpersonEmail.Text<>'' then
  begin
    if Not form1.ValidateEmail(edtKontaktpersonEmail.text) then
    begin
      edtKontaktpersonEmail.SetFocus;
      showmessage('Kontaktperson Email ist nicht gültig');
      exit;
    end;
   end;
  xdsProdukte.Locate('Produkt',edtTicketGrund.Text,[]);

  xdsTicket.Append;
  xdsTicketKundennummer.Value:=xdsKundendaten.CurrentData;
  xdsTicketProdukt.Value:=xdsProdukte.CurrentData;
  xdsTicketStatus.Value:=xdsStatus.CurrentData;
  xdsTicketKategorie.Value:=xdsKategorie.CurrentData;
  xdsTicketPrioritaet.Value:=xdsprioritaet.CurrentData;
  xdsTicketErstelltAm.AsDateTime:=date+time;
  xdsTicketBetreff.AsString:=edtBetreff.Text;
  xdsTicketBeschreibung.AsString:=edtBeschreibung.Text;
  xdsTicketAbrechnungsbetrag.AsFloat:=0;
  xdsTicketSystemInfo.AsString:=edtSystemInfo.Text;
  xdsTicketZeitaufwandMinuten.AsInteger:=0;
  xdsTicketAbzurechnendeMinuten.AsInteger:=0;
  xdsTicketKontaktperson.AsString:=edtKontaktperson.Text;
  xdsTicketKontaktpersonEmail.AsString:=edtKontaktpersonEmail.Text;
  xdsTicketErreichbarkeitTelefon.AsString:=edtTelefon.Text;
  xdsTicketErreichbarkeitWann.AsString:=edtWann.Text;
  xdsTicketNachname.AsString:=xdsKundendatenNachname.AsString;
  xdsTicketVorname.AsString:=xdsKundendatenVorname.AsString;
  xdsTicketEmail.AsString:=xdsKundendatenEMail.AsString;
  xdsTicketProtokoll.AsString:=datetimetostr(date+time)+' NEU Kundenportal';
  xdsticket.Post;
end;

procedure TTicketNeu.Formularaktualisieren;
var
  i:integer;
  myelement:TJSHTMLElement;
  myhtmlstring:string;
begin
  myelement:=container1.ElementHandle;
  paneltop.parentelement:=myelement;
  panelfunctions.ParentElement:=myelement;
  container2.ParentElement:=myelement;

  myelement:=paneltop.ElementHandle;
  lblseite.ParentElement:=myelement;

  myelement:=panelfunctions.ElementHandle;
  btnZurueck.ParentElement:=myelement;

  myelement:=container2.ElementHandle;
  tc.ParentElement:=myelement;

  TC.ColCount:=1;
  tc.RowCount:=19;

  i:=0;

  tc.Cells[0,i]:='<h5>Daten für das neue Ticket';
  inc(i);
  TC.Cells[0,i]:='Produkt auswählen*<br>';
  myelement:=TC.CellElements[0,i];
  edtTicketGrund:=TComboBox.Create(self);
  edtTicketGrund.ElementClassName:='form-control';
  edtTicketGrund.Width:=400;
  edtTicketGrund.HeightStyle:=ssAuto;
  edtTicketGrund.ItemIndex:=-1;
  edtTicketGrund.ParentElement:=myelement;
  edtTicketGrund.Items.Clear;
  xdsProdukte.First;
  while not xdsProdukte.eof do
  begin
    edtTicketGrund.Items.Add(xdsProdukteProdukt.AsString);
    xdsProdukte.Next;
  end;


  inc(i);
  TC.Cells[0,i]:='Betreff*<br>';
  myelement:=TC.CellElements[0,i];
  edtBetreff:=TEdit.Create(self);
  edtBetreff.ElementClassName:='form-control';
  edtBetreff.Width:=400;
  edtBetreff.HeightStyle:=ssAuto;
  edtBetreff.TextHint:='Betreff';
  edtBetreff.MaxLength:=100;
  edtBetreff.ParentElement:=myelement;

  if TicketNeuBetreff<>'' then
  begin
    edtbetreff.Text:=TicketNeuBetreff;
    ticketneubetreff:='';
  end;

  inc(i);
  TC.Cells[0,i]:='Beschreibung*<br>';
  myelement:=TC.CellElements[0,i];
  edtBeschreibung:=TMemo.Create(self);
  edtBeschreibung.ElementClassName:='form-control';
  edtBeschreibung.WidthStyle:=ssAuto;
  edtBeschreibung.Height:=200;
  edtBeschreibung.HeightStyle:=ssAbsolute;
  edtBeschreibung.TextHint:='Beschreibung';
  edtBeschreibung.ParentElement:=myelement;
  if TicketNeuText<>'' then
  begin
    edtbeschreibung.Text:=TicketNeuText;
    TicketNeuText:='';
  end;
  inc(i);
  TC.Cells[0,i]:='Kontaktperson*<br>';
  myelement:=TC.CellElements[0,i];
  edtKontaktperson:=TEdit.Create(self);
  edtKontaktperson.ElementClassName:='form-control';
  edtKontaktperson.Width:=400;
  edtKontaktperson.HeightStyle:=ssAuto;
  edtKontaktperson.TextHint:='Ansprechpartner für diese Ticket';
  edtKontaktperson.MaxLength:=100;
  edtKontaktperson.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Kontaktperson Email für Ticket-Benachrichtigungen (optional)<br>';
  myelement:=TC.CellElements[0,i];
  edtKontaktpersonEmail:=TEdit.Create(self);
  edtKontaktpersonEmail.ElementClassName:='form-control email';
  edtKontaktpersonEmail.Width:=400;
  edtKontaktpersonEmail.HeightStyle:=ssAuto;
  edtKontaktpersonEmail.TextHint:='Benachrichtigungen zusätzlich an diese Emailadresse senden';
  edtKontaktpersonEmail.MaxLength:=100;
  edtKontaktpersonEmail.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Ihre Telefonnummer*<br>';
  myelement:=TC.CellElements[0,i];
  edtTelefon:=TEdit.Create(self);
  edtTelefon.ElementClassName:='form-control';
  edtTelefon.Width:=400;
  edtTelefon.HeightStyle:=ssAuto;
  edtTelefon.TextHint:='Ansprechpartner Telefonnummer';
  edtTelefon.MaxLength:=100;
  edtTelefon.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Wann sind Sie erreichbar?*<br>';
  myelement:=TC.CellElements[0,i];
  edtWann:=TEdit.Create(self);
  edtWann.ElementClassName:='form-control';
  edtWann.Width:=400;
  edtWann.HeightStyle:=ssAuto;
  edtWann.TextHint:='Uhrzeit für Erreichbarkeit';
  edtWann.MaxLength:=100;
  edtWann.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Informationen zum Betriebssystem, Programmversions-Nr. und -Datum, andere hilfreiche Infos<br>';
  myelement:=TC.CellElements[0,i];
  edtSystemInfo:=TMemo.Create(self);
  edtSystemInfo.ElementClassName:='form-control';
  edtSystemInfo.WidthStyle:=ssAuto;
  edtSystemInfo.Height:=200;
  edtSystemInfo.HeightStyle:=ssAbsolute;
  edtSystemInfo.TextHint:='weitere Infos';
  edtSystemInfo.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Anlagen (max. 3 Dateien) JPG, JPEG, PNG, PDF, ZIP, TXT (max. 2 MB pro Datei) hinzufügen:';

  inc(i);
  myelement:=TC.cellelements[0,i];
  WebFilePicker1.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  WebFilePicker2.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  WebFilePicker3.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  btnAbsenden:=TButton.Create(self);
  btnAbsenden.ElementClassName:='btn btn-sm bg-info m-1';
  btnAbsenden.HeightStyle:=ssauto;
  btnAbsenden.WidthStyle:=ssauto;
  btnAbsenden.tag:=0;
  btnAbsenden.Caption:='Absenden';
  btnAbsenden.OnClick:=@btnAbsendenClick;
  btnAbsenden.ParentElement:=myelement;




end;

procedure TTicketNeu.WebFilePicker1Change(Sender: TObject);
begin
  file1base64str1:='';
  if WebFilePicker1.Files.Count>0 then
  begin
    if WebFilePicker1.Files.Items[0].Size<2097153 then
    begin
      webfilepicker1.Files.Items[0].GetFileAsBase64;
    end
    else
    begin
      showmessage('Datei ist zu groß, bitte andere Datei wählen');
    end;
  end;
end;

procedure TTicketNeu.WebFilePicker1GetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  file1base64str1:= 'data:' + WebFilePicker1.Files.Items[0].MimeType + ';base64,' + ABase64;
end;

procedure TTicketNeu.WebFilePicker2Change(Sender: TObject);
begin
  file1base64str2:='';
  if WebFilePicker2.Files.Count>0 then
  begin
    if WebFilePicker2.Files.Items[0].Size<2097153 then
    begin
      webfilepicker2.Files.Items[0].GetFileAsBase64;
    end
    else
    begin
      showmessage('Datei ist zu groß, bitte andere Datei wählen');
    end;
  end;
end;

procedure TTicketNeu.WebFilePicker2GetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
file1base64str2:= 'data:' + WebFilePicker2.Files.Items[0].MimeType + ';base64,' + ABase64;
end;

procedure TTicketNeu.WebFilePicker3Change(Sender: TObject);
begin
  file1base64str3:='';
  if WebFilePicker3.Files.Count>0 then
  begin
    if WebFilePicker3.Files.Items[0].Size<2097153 then
    begin
      webfilepicker3.Files.Items[0].GetFileAsBase64;
    end
    else
    begin
      showmessage('Datei ist zu groß, bitte andere Datei wählen');
    end;
  end;
end;

procedure TTicketNeu.WebFilePicker3GetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  file1base64str3:= 'data:' + WebFilePicker3.Files.Items[0].MimeType + ';base64,' + ABase64;
end;

procedure TTicketNeu.WebFormShow(Sender: TObject);
begin
  xdsKontosaldo.Close;
  xdsKontosaldo.QueryString:='$filter=Kundennummer eq '+QuotedStr(TicketNeuFuerKundennummer);
  xdsKontosaldo.Load;
end;

procedure TTicketNeu.xdsKategorieAfterOpen(DataSet: TDataSet);
begin
  xdsKategorie.Locate('Kategorie','[-]',[]);
  xdsprioritaet.Load;

end;

procedure TTicketNeu.xdsKontosaldoAfterOpen(DataSet: TDataSet);
begin
  xdsProdukte.Load;

end;

procedure TTicketNeu.xdsKundendatenAfterOpen(DataSet: TDataSet);
begin
  xdsStatus.Load;

end;

procedure TTicketNeu.xdsprioritaetAfterOpen(DataSet: TDataSet);
begin
  xdsprioritaet.Locate('Prioritaet','3',[]);
  Formularaktualisieren;
end;

procedure TTicketNeu.xdsProdukteAfterOpen(DataSet: TDataSet);
begin
  xdsTicket.Load;
end;

procedure TTicketNeu.xdsStatusAfterOpen(DataSet: TDataSet);
begin
  xdsStatus.Locate('Status','ungelesen',[]);
  xdsKategorie.Load;

end;

procedure TTicketNeu.xdsticket2AfterOpen(DataSet: TDataSet);
begin
  NewTicketNumber:=xdsticket2id.asstring;
  uploadfilepickers;
end;

procedure TTicketNeu.xdsTicketAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    xdsticket2.Load;

  end;
end;

procedure TTicketNeu.xdsTicketAfterOpen(DataSet: TDataSet);
begin
  xdsTicketDateien.Load;
end;

procedure TTicketNeu.xdsTicketAfterPost(DataSet: TDataSet);
begin
  xdsTicket.ApplyUpdates;
end;

procedure TTicketNeu.xdsTicketDateienAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    showmessage('Das Ticket wurde erfolgreich erstellt.');
    close;
  end;

end;

procedure TTicketNeu.xdsTicketDateienAfterOpen(DataSet: TDataSet);
begin
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(TicketNeuFuerKundennummer);
  xdsKundendaten.Load;
end;

procedure TTicketNeu.xdsTicketDateienNewRecord(DataSet: TDataSet);
begin
  xdsTicketDateienDatumUhrzeit.AsDateTime:=date+time;
  xdsTicketDateienFuerLoesung.AsInteger:=0;
  xdsTicketDateienTicketID.Value:=xdsTicket.CurrentData;
end;

procedure TTicketNeu.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  WebFilePicker1 := TFilePicker.Create(Self);
  WebFilePicker2 := TFilePicker.Create(Self);
  WebFilePicker3 := TFilePicker.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  PanelTop := TPanel.Create(Self);
  lblSeite := TLabel.Create(Self);
  panelfunctions := TPanel.Create(Self);
  btnzurueck := TButton.Create(Self);
  xdsKontosaldo := TXDataWebDataSet.Create(Self);
  xdsKontosaldoKundennummer := TStringField.Create(Self);
  xdsKontosaldoZeitaufwand := TIntegerField.Create(Self);
  xdsKontosaldoAbzurechnen := TIntegerField.Create(Self);
  xdsKontosaldoGutschrift := TIntegerField.Create(Self);
  xdsKontosaldoAbzug := TIntegerField.Create(Self);
  xdsKontosaldoSaldo := TIntegerField.Create(Self);
  xdsKontosaldoBetrag := TFloatField.Create(Self);
  xdsKontosaldoMinutenpreis := TFloatField.Create(Self);
  xdsKontosaldoSRestguthaben := TIntegerField.Create(Self);
  xdsTicket := TXDataWebDataSet.Create(Self);
  xdsTicketKundennummer := TXDataWebEntityField.Create(Self);
  xdsTicketProdukt := TXDataWebEntityField.Create(Self);
  xdsTicketKategorie := TXDataWebEntityField.Create(Self);
  xdsTicketPrioritaet := TXDataWebEntityField.Create(Self);
  xdsTicketStatus := TXDataWebEntityField.Create(Self);
  xdsTicketID := TIntegerField.Create(Self);
  xdsTicketErstelltAm := TDateTimeField.Create(Self);
  xdsTicketBetreff := TStringField.Create(Self);
  xdsTicketBeschreibung := TStringField.Create(Self);
  xdsTicketAbrechnungsbetrag := TFloatField.Create(Self);
  xdsTicketAbrechnungRechnungsnummer := TStringField.Create(Self);
  xdsTicketAberechnetAm := TDateTimeField.Create(Self);
  xdsTicketErledigtAm := TDateTimeField.Create(Self);
  xdsTicketNachname := TStringField.Create(Self);
  xdsTicketVorname := TStringField.Create(Self);
  xdsTicketEmail := TStringField.Create(Self);
  xdsTicketSystemInfo := TStringField.Create(Self);
  xdsTicketLoesung := TStringField.Create(Self);
  xdsTicketProtokoll := TStringField.Create(Self);
  xdsTicketZeitaufwandMinuten := TIntegerField.Create(Self);
  xdsTicketAbzurechnendeMinuten := TIntegerField.Create(Self);
  xdsTicketAbgerechneteMinuten := TIntegerField.Create(Self);
  xdsTicketBenachrichtigungNEU := TDateTimeField.Create(Self);
  xdsTicketBenachrichtigungLoesung := TDateTimeField.Create(Self);
  xdsTicketInterneBemerkung := TStringField.Create(Self);
  xdsTicketLoesungInfoSenden := TIntegerField.Create(Self);
  xdsTicketKontaktperson := TStringField.Create(Self);
  xdsTicketErreichbarkeitTelefon := TStringField.Create(Self);
  xdsTicketErreichbarkeitWann := TStringField.Create(Self);
  xdsTicketKontaktpersonEmail := TStringField.Create(Self);
  xdsProdukte := TXDataWebDataSet.Create(Self);
  xdsProdukteProdukt := TStringField.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenGruppeKunden := TBooleanField.Create(Self);
  xdsKundendatenGruppeLieferanten := TBooleanField.Create(Self);
  xdsKundendatenGruppeSonstige := TBooleanField.Create(Self);
  xdsKundendatenGruppeNichtkunden := TBooleanField.Create(Self);
  xdsKundendatenKontaktgruppe := TStringField.Create(Self);
  xdsKundendatenNachname := TStringField.Create(Self);
  xdsKundendatenVorname := TStringField.Create(Self);
  xdsKundendatenAdresszeile2 := TStringField.Create(Self);
  xdsKundendatenAdresszeile3 := TStringField.Create(Self);
  xdsKundendatenStrasse := TStringField.Create(Self);
  xdsKundendatenPostleitzahl := TStringField.Create(Self);
  xdsKundendatenOrt := TStringField.Create(Self);
  xdsKundendatenLaenderkuerzel := TStringField.Create(Self);
  xdsKundendatenLand := TStringField.Create(Self);
  xdsKundendatenLaenderkennzeichen := TBooleanField.Create(Self);
  xdsKundendatenAdressanrede := TStringField.Create(Self);
  xdsKundendatenBriefanrede1 := TStringField.Create(Self);
  xdsKundendatenAdresseBild := TStringField.Create(Self);
  xdsKundendatenLieferanschrift := TStringField.Create(Self);
  xdsKundendatenTelefonNummer := TStringField.Create(Self);
  xdsKundendatenTelefaxNummer := TStringField.Create(Self);
  xdsKundendatenMobilTelefon := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenInternet := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerID := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsKundendatenZahlungsbedingung := TIntegerField.Create(Self);
  xdsKundendatenTransportbedingung := TStringField.Create(Self);
  xdsKundendatenKeinNewsletter := TBooleanField.Create(Self);
  xdsKundendatenTelefonAlternativ := TStringField.Create(Self);
  xdsKundendatenTitel := TStringField.Create(Self);
  xdsKundendatenKundenklasseFarbe := TIntegerField.Create(Self);
  xdsKundendatenRechnungEmail := TStringField.Create(Self);
  xdsKundendatenLoginPW := TStringField.Create(Self);
  xdsKundendatenBesteuerungKey := TIntegerField.Create(Self);
  xdsKundendatenAuftraegeJahr := TFloatField.Create(Self);
  xdsKundendatenAuftraegeVorjahr := TFloatField.Create(Self);
  xdsKundendatenLieferadresseID := TIntegerField.Create(Self);
  xdsKundendatenUSTIDgeprueft := TDateTimeField.Create(Self);
  xdsKundendatenKontaktverbund := TStringField.Create(Self);
  xdsKundendatenHinweis := TStringField.Create(Self);
  xdsKundendatenLatitude := TFloatField.Create(Self);
  xdsKundendatenLongitude := TFloatField.Create(Self);
  xdsKundendatenkmLuftlinie := TFloatField.Create(Self);
  xdsKundendatenGoogleID := TStringField.Create(Self);
  xdsKundendatenGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsKundendatenBundesland := TStringField.Create(Self);
  xdsKundendatenRegion := TStringField.Create(Self);
  xdsKundendatenMandatsreferenz := TStringField.Create(Self);
  xdsKundendatenMandatsreferenzVom := TDateTimeField.Create(Self);
  xdsKundendatenLastschriftArt := TStringField.Create(Self);
  xdsKundendatenMahnsperre := TBooleanField.Create(Self);
  xdsKundendatenSuchbegriff := TStringField.Create(Self);
  xdsKundendatenLieferanschriftDaten := TStringField.Create(Self);
  xdsKundendatenExportKasse := TBooleanField.Create(Self);
  xdsKundendatenLoeschvormerkungDatum := TDateTimeField.Create(Self);
  xdsKundendatenLoeschvormerkungGrund := TStringField.Create(Self);
  xdsKundendatenPseudonymisiert := TStringField.Create(Self);
  xdsKundendatenLoginAktiv := TIntegerField.Create(Self);
  xdsKundendatenSonstigeDaten := TStringField.Create(Self);
  xdsStatus := TXDataWebDataSet.Create(Self);
  xdsStatusStatus := TStringField.Create(Self);
  xdsKategorie := TXDataWebDataSet.Create(Self);
  xdsKategorieKategorie := TStringField.Create(Self);
  xdsprioritaet := TXDataWebDataSet.Create(Self);
  xdsprioritaetPrioritaet := TIntegerField.Create(Self);
  xdsprioritaetPrioText := TStringField.Create(Self);
  xdsprioritaetPrioFarbe := TIntegerField.Create(Self);
  xdsTicketDateien := TXDataWebDataSet.Create(Self);
  xdsTicketDateienTicketID := TXDataWebEntityField.Create(Self);
  xdsTicketDateienID := TIntegerField.Create(Self);
  xdsTicketDateienDatumUhrzeit := TDateTimeField.Create(Self);
  xdsTicketDateienFuerLoesung := TIntegerField.Create(Self);
  xdsTicketDateienDateiMime := TStringField.Create(Self);
  xdsTicketDateienDateiName := TStringField.Create(Self);
  xdsTicketDateienDateiGroesse := TIntegerField.Create(Self);
  xdsTicketDateienDateiInhaltText := TStringField.Create(Self);
  xdsticket2 := TXDataWebDataSet.Create(Self);
  xdsticket2Kundennummer := TXDataWebEntityField.Create(Self);
  xdsticket2Produkt := TXDataWebEntityField.Create(Self);
  xdsticket2Kategorie := TXDataWebEntityField.Create(Self);
  xdsticket2Prioritaet := TXDataWebEntityField.Create(Self);
  xdsticket2Status := TXDataWebEntityField.Create(Self);
  xdsticket2ID := TIntegerField.Create(Self);
  xdsticket2ErstelltAm := TDateTimeField.Create(Self);
  xdsticket2Betreff := TStringField.Create(Self);
  xdsticket2Beschreibung := TStringField.Create(Self);
  xdsticket2Abrechnungsbetrag := TFloatField.Create(Self);
  xdsticket2AbrechnungRechnungsnummer := TStringField.Create(Self);
  xdsticket2AberechnetAm := TDateTimeField.Create(Self);
  xdsticket2ErledigtAm := TDateTimeField.Create(Self);
  xdsticket2Nachname := TStringField.Create(Self);
  xdsticket2Vorname := TStringField.Create(Self);
  xdsticket2Email := TStringField.Create(Self);
  xdsticket2SystemInfo := TStringField.Create(Self);
  xdsticket2Loesung := TStringField.Create(Self);
  xdsticket2Protokoll := TStringField.Create(Self);
  xdsticket2ZeitaufwandMinuten := TIntegerField.Create(Self);
  xdsticket2AbzurechnendeMinuten := TIntegerField.Create(Self);
  xdsticket2AbgerechneteMinuten := TIntegerField.Create(Self);
  xdsticket2BenachrichtigungNEU := TDateTimeField.Create(Self);
  xdsticket2BenachrichtigungLoesung := TDateTimeField.Create(Self);
  xdsticket2InterneBemerkung := TStringField.Create(Self);
  xdsticket2LoesungInfoSenden := TIntegerField.Create(Self);
  xdsticket2Kontaktperson := TStringField.Create(Self);
  xdsticket2KontaktpersonEmail := TStringField.Create(Self);
  xdsticket2ErreichbarkeitTelefon := TStringField.Create(Self);
  xdsticket2ErreichbarkeitWann := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  WebFilePicker1.BeforeLoadDFMValues;
  WebFilePicker2.BeforeLoadDFMValues;
  WebFilePicker3.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  PanelTop.BeforeLoadDFMValues;
  lblSeite.BeforeLoadDFMValues;
  panelfunctions.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  xdsKontosaldo.BeforeLoadDFMValues;
  xdsKontosaldoKundennummer.BeforeLoadDFMValues;
  xdsKontosaldoZeitaufwand.BeforeLoadDFMValues;
  xdsKontosaldoAbzurechnen.BeforeLoadDFMValues;
  xdsKontosaldoGutschrift.BeforeLoadDFMValues;
  xdsKontosaldoAbzug.BeforeLoadDFMValues;
  xdsKontosaldoSaldo.BeforeLoadDFMValues;
  xdsKontosaldoBetrag.BeforeLoadDFMValues;
  xdsKontosaldoMinutenpreis.BeforeLoadDFMValues;
  xdsKontosaldoSRestguthaben.BeforeLoadDFMValues;
  xdsTicket.BeforeLoadDFMValues;
  xdsTicketKundennummer.BeforeLoadDFMValues;
  xdsTicketProdukt.BeforeLoadDFMValues;
  xdsTicketKategorie.BeforeLoadDFMValues;
  xdsTicketPrioritaet.BeforeLoadDFMValues;
  xdsTicketStatus.BeforeLoadDFMValues;
  xdsTicketID.BeforeLoadDFMValues;
  xdsTicketErstelltAm.BeforeLoadDFMValues;
  xdsTicketBetreff.BeforeLoadDFMValues;
  xdsTicketBeschreibung.BeforeLoadDFMValues;
  xdsTicketAbrechnungsbetrag.BeforeLoadDFMValues;
  xdsTicketAbrechnungRechnungsnummer.BeforeLoadDFMValues;
  xdsTicketAberechnetAm.BeforeLoadDFMValues;
  xdsTicketErledigtAm.BeforeLoadDFMValues;
  xdsTicketNachname.BeforeLoadDFMValues;
  xdsTicketVorname.BeforeLoadDFMValues;
  xdsTicketEmail.BeforeLoadDFMValues;
  xdsTicketSystemInfo.BeforeLoadDFMValues;
  xdsTicketLoesung.BeforeLoadDFMValues;
  xdsTicketProtokoll.BeforeLoadDFMValues;
  xdsTicketZeitaufwandMinuten.BeforeLoadDFMValues;
  xdsTicketAbzurechnendeMinuten.BeforeLoadDFMValues;
  xdsTicketAbgerechneteMinuten.BeforeLoadDFMValues;
  xdsTicketBenachrichtigungNEU.BeforeLoadDFMValues;
  xdsTicketBenachrichtigungLoesung.BeforeLoadDFMValues;
  xdsTicketInterneBemerkung.BeforeLoadDFMValues;
  xdsTicketLoesungInfoSenden.BeforeLoadDFMValues;
  xdsTicketKontaktperson.BeforeLoadDFMValues;
  xdsTicketErreichbarkeitTelefon.BeforeLoadDFMValues;
  xdsTicketErreichbarkeitWann.BeforeLoadDFMValues;
  xdsTicketKontaktpersonEmail.BeforeLoadDFMValues;
  xdsProdukte.BeforeLoadDFMValues;
  xdsProdukteProdukt.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenGruppeKunden.BeforeLoadDFMValues;
  xdsKundendatenGruppeLieferanten.BeforeLoadDFMValues;
  xdsKundendatenGruppeSonstige.BeforeLoadDFMValues;
  xdsKundendatenGruppeNichtkunden.BeforeLoadDFMValues;
  xdsKundendatenKontaktgruppe.BeforeLoadDFMValues;
  xdsKundendatenNachname.BeforeLoadDFMValues;
  xdsKundendatenVorname.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile2.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile3.BeforeLoadDFMValues;
  xdsKundendatenStrasse.BeforeLoadDFMValues;
  xdsKundendatenPostleitzahl.BeforeLoadDFMValues;
  xdsKundendatenOrt.BeforeLoadDFMValues;
  xdsKundendatenLaenderkuerzel.BeforeLoadDFMValues;
  xdsKundendatenLand.BeforeLoadDFMValues;
  xdsKundendatenLaenderkennzeichen.BeforeLoadDFMValues;
  xdsKundendatenAdressanrede.BeforeLoadDFMValues;
  xdsKundendatenBriefanrede1.BeforeLoadDFMValues;
  xdsKundendatenAdresseBild.BeforeLoadDFMValues;
  xdsKundendatenLieferanschrift.BeforeLoadDFMValues;
  xdsKundendatenTelefonNummer.BeforeLoadDFMValues;
  xdsKundendatenTelefaxNummer.BeforeLoadDFMValues;
  xdsKundendatenMobilTelefon.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenInternet.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerID.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsKundendatenZahlungsbedingung.BeforeLoadDFMValues;
  xdsKundendatenTransportbedingung.BeforeLoadDFMValues;
  xdsKundendatenKeinNewsletter.BeforeLoadDFMValues;
  xdsKundendatenTelefonAlternativ.BeforeLoadDFMValues;
  xdsKundendatenTitel.BeforeLoadDFMValues;
  xdsKundendatenKundenklasseFarbe.BeforeLoadDFMValues;
  xdsKundendatenRechnungEmail.BeforeLoadDFMValues;
  xdsKundendatenLoginPW.BeforeLoadDFMValues;
  xdsKundendatenBesteuerungKey.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeJahr.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeVorjahr.BeforeLoadDFMValues;
  xdsKundendatenLieferadresseID.BeforeLoadDFMValues;
  xdsKundendatenUSTIDgeprueft.BeforeLoadDFMValues;
  xdsKundendatenKontaktverbund.BeforeLoadDFMValues;
  xdsKundendatenHinweis.BeforeLoadDFMValues;
  xdsKundendatenLatitude.BeforeLoadDFMValues;
  xdsKundendatenLongitude.BeforeLoadDFMValues;
  xdsKundendatenkmLuftlinie.BeforeLoadDFMValues;
  xdsKundendatenGoogleID.BeforeLoadDFMValues;
  xdsKundendatenGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsKundendatenBundesland.BeforeLoadDFMValues;
  xdsKundendatenRegion.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenz.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenzVom.BeforeLoadDFMValues;
  xdsKundendatenLastschriftArt.BeforeLoadDFMValues;
  xdsKundendatenMahnsperre.BeforeLoadDFMValues;
  xdsKundendatenSuchbegriff.BeforeLoadDFMValues;
  xdsKundendatenLieferanschriftDaten.BeforeLoadDFMValues;
  xdsKundendatenExportKasse.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungDatum.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungGrund.BeforeLoadDFMValues;
  xdsKundendatenPseudonymisiert.BeforeLoadDFMValues;
  xdsKundendatenLoginAktiv.BeforeLoadDFMValues;
  xdsKundendatenSonstigeDaten.BeforeLoadDFMValues;
  xdsStatus.BeforeLoadDFMValues;
  xdsStatusStatus.BeforeLoadDFMValues;
  xdsKategorie.BeforeLoadDFMValues;
  xdsKategorieKategorie.BeforeLoadDFMValues;
  xdsprioritaet.BeforeLoadDFMValues;
  xdsprioritaetPrioritaet.BeforeLoadDFMValues;
  xdsprioritaetPrioText.BeforeLoadDFMValues;
  xdsprioritaetPrioFarbe.BeforeLoadDFMValues;
  xdsTicketDateien.BeforeLoadDFMValues;
  xdsTicketDateienTicketID.BeforeLoadDFMValues;
  xdsTicketDateienID.BeforeLoadDFMValues;
  xdsTicketDateienDatumUhrzeit.BeforeLoadDFMValues;
  xdsTicketDateienFuerLoesung.BeforeLoadDFMValues;
  xdsTicketDateienDateiMime.BeforeLoadDFMValues;
  xdsTicketDateienDateiName.BeforeLoadDFMValues;
  xdsTicketDateienDateiGroesse.BeforeLoadDFMValues;
  xdsTicketDateienDateiInhaltText.BeforeLoadDFMValues;
  xdsticket2.BeforeLoadDFMValues;
  xdsticket2Kundennummer.BeforeLoadDFMValues;
  xdsticket2Produkt.BeforeLoadDFMValues;
  xdsticket2Kategorie.BeforeLoadDFMValues;
  xdsticket2Prioritaet.BeforeLoadDFMValues;
  xdsticket2Status.BeforeLoadDFMValues;
  xdsticket2ID.BeforeLoadDFMValues;
  xdsticket2ErstelltAm.BeforeLoadDFMValues;
  xdsticket2Betreff.BeforeLoadDFMValues;
  xdsticket2Beschreibung.BeforeLoadDFMValues;
  xdsticket2Abrechnungsbetrag.BeforeLoadDFMValues;
  xdsticket2AbrechnungRechnungsnummer.BeforeLoadDFMValues;
  xdsticket2AberechnetAm.BeforeLoadDFMValues;
  xdsticket2ErledigtAm.BeforeLoadDFMValues;
  xdsticket2Nachname.BeforeLoadDFMValues;
  xdsticket2Vorname.BeforeLoadDFMValues;
  xdsticket2Email.BeforeLoadDFMValues;
  xdsticket2SystemInfo.BeforeLoadDFMValues;
  xdsticket2Loesung.BeforeLoadDFMValues;
  xdsticket2Protokoll.BeforeLoadDFMValues;
  xdsticket2ZeitaufwandMinuten.BeforeLoadDFMValues;
  xdsticket2AbzurechnendeMinuten.BeforeLoadDFMValues;
  xdsticket2AbgerechneteMinuten.BeforeLoadDFMValues;
  xdsticket2BenachrichtigungNEU.BeforeLoadDFMValues;
  xdsticket2BenachrichtigungLoesung.BeforeLoadDFMValues;
  xdsticket2InterneBemerkung.BeforeLoadDFMValues;
  xdsticket2LoesungInfoSenden.BeforeLoadDFMValues;
  xdsticket2Kontaktperson.BeforeLoadDFMValues;
  xdsticket2KontaktpersonEmail.BeforeLoadDFMValues;
  xdsticket2ErreichbarkeitTelefon.BeforeLoadDFMValues;
  xdsticket2ErreichbarkeitWann.BeforeLoadDFMValues;
  try
    Name := 'TicketNeu';
    Width := 617;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 344;
    TC.Width := 190;
    TC.Height := 136;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-primary';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    WebFilePicker1.SetParentComponent(Self);
    WebFilePicker1.Name := 'WebFilePicker1';
    WebFilePicker1.Left := 32;
    WebFilePicker1.Top := 216;
    WebFilePicker1.Width := 129;
    WebFilePicker1.Height := 19;
    WebFilePicker1.ElementClassName := 'form-control';
    WebFilePicker1.HeightStyle := ssAuto;
    WebFilePicker1.WidthStyle := ssAuto;
    WebFilePicker1.Accept := '.jpg,.jpeg,.png,.txt,.pdf,.zip';
    WebFilePicker1.ChildOrder := 1;
    WebFilePicker1.ElementFont := efCSS;
    WebFilePicker1.ElementPosition := epIgnore;
    SetEvent(WebFilePicker1, Self, 'OnChange', 'WebFilePicker1Change');
    SetEvent(WebFilePicker1, Self, 'OnGetFileAsBase64', 'WebFilePicker1GetFileAsBase64');
    WebFilePicker2.SetParentComponent(Self);
    WebFilePicker2.Name := 'WebFilePicker2';
    WebFilePicker2.Left := 32;
    WebFilePicker2.Top := 241;
    WebFilePicker2.Width := 129;
    WebFilePicker2.Height := 19;
    WebFilePicker2.ElementClassName := 'form-control';
    WebFilePicker2.HeightStyle := ssAuto;
    WebFilePicker2.WidthStyle := ssAuto;
    WebFilePicker2.Accept := '.jpg,.jpeg,.png,.pdf,.txt';
    WebFilePicker2.ChildOrder := 1;
    WebFilePicker2.ElementFont := efCSS;
    WebFilePicker2.ElementPosition := epIgnore;
    SetEvent(WebFilePicker2, Self, 'OnChange', 'WebFilePicker2Change');
    SetEvent(WebFilePicker2, Self, 'OnGetFileAsBase64', 'WebFilePicker2GetFileAsBase64');
    WebFilePicker3.SetParentComponent(Self);
    WebFilePicker3.Name := 'WebFilePicker3';
    WebFilePicker3.Left := 32;
    WebFilePicker3.Top := 266;
    WebFilePicker3.Width := 129;
    WebFilePicker3.Height := 19;
    WebFilePicker3.ElementClassName := 'form-control';
    WebFilePicker3.HeightStyle := ssAuto;
    WebFilePicker3.WidthStyle := ssAuto;
    WebFilePicker3.Accept := '.jpg,.jpeg,.png,.pdf,.txt';
    WebFilePicker3.ChildOrder := 1;
    WebFilePicker3.ElementFont := efCSS;
    WebFilePicker3.ElementPosition := epIgnore;
    SetEvent(WebFilePicker3, Self, 'OnChange', 'WebFilePicker3Change');
    SetEvent(WebFilePicker3, Self, 'OnGetFileAsBase64', 'WebFilePicker3GetFileAsBase64');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.ElementClassName := 'container-fluid rounded';
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 2;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container2.ScrollStyle := ssNone;
    PanelTop.SetParentComponent(Self);
    PanelTop.Name := 'PanelTop';
    PanelTop.Left := 0;
    PanelTop.Top := 94;
    PanelTop.Width := 463;
    PanelTop.Height := 76;
    PanelTop.ElementClassName := 'd-flex flex-wrap bg-info rounded';
    PanelTop.HeightStyle := ssAuto;
    PanelTop.WidthStyle := ssPercent;
    PanelTop.BorderStyle := bsNone;
    PanelTop.Caption := 'WebPanel1';
    PanelTop.ChildOrder := 2;
    PanelTop.Color := 8340248;
    PanelTop.ElementFont := efCSS;
    PanelTop.ElementPosition := epIgnore;
    PanelTop.ShowCaption := False;
    lblSeite.SetParentComponent(PanelTop);
    lblSeite.Name := 'lblSeite';
    lblSeite.Left := 1;
    lblSeite.Top := 1;
    lblSeite.Width := 163;
    lblSeite.Height := 25;
    lblSeite.AutoSize := False;
    lblSeite.Caption := 'Neues Ticket';
    lblSeite.ElementClassName := 'h2 text-light m-1';
    lblSeite.ElementLabelClassName := 'align-self-start';
    lblSeite.ElementFont := efCSS;
    lblSeite.ElementPosition := epIgnore;
    lblSeite.Font.Charset := DEFAULT_CHARSET;
    lblSeite.Font.Color := clWindowText;
    lblSeite.Font.Height := -19;
    lblSeite.Font.Name := 'Segoe UI';
    lblSeite.Font.Style := [];
    lblSeite.HeightStyle := ssAuto;
    lblSeite.HeightPercent := 100.000000000000000000;
    lblSeite.ParentFont := False;
    lblSeite.WidthStyle := ssPercent;
    lblSeite.WidthPercent := 100.000000000000000000;
    panelfunctions.SetParentComponent(Self);
    panelfunctions.Name := 'panelfunctions';
    panelfunctions.Left := 8;
    panelfunctions.Top := 212;
    panelfunctions.Width := 257;
    panelfunctions.Height := 37;
    panelfunctions.ElementClassName := 'd-flex flex-wrap';
    panelfunctions.HeightStyle := ssAuto;
    panelfunctions.WidthStyle := ssPercent;
    panelfunctions.BorderColor := 13892310;
    panelfunctions.BorderStyle := bsNone;
    panelfunctions.ChildOrder := 1;
    panelfunctions.Color := clWhite;
    panelfunctions.ElementFont := efCSS;
    panelfunctions.ElementPosition := epIgnore;
    panelfunctions.ShowCaption := False;
    btnzurueck.SetParentComponent(panelfunctions);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 3;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-sm bg-info m-1';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    xdsKontosaldo.SetParentComponent(Self);
    xdsKontosaldo.Name := 'xdsKontosaldo';
    xdsKontosaldo.AfterOpen := xdsKontosaldoAfterOpen;
    xdsKontosaldo.EntitySetName := 'ITS_Kontosalden';
    xdsKontosaldo.Connection := DM2.XDataWebConnection1;
    xdsKontosaldo.Left := 32;
    xdsKontosaldo.Top := 288;
    xdsKontosaldoKundennummer.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoKundennummer.Name := 'xdsKontosaldoKundennummer';
    xdsKontosaldoKundennummer.FieldName := 'Kundennummer';
    xdsKontosaldoKundennummer.Required := True;
    xdsKontosaldoKundennummer.Size := 13;
    xdsKontosaldoZeitaufwand.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoZeitaufwand.Name := 'xdsKontosaldoZeitaufwand';
    xdsKontosaldoZeitaufwand.FieldName := 'Zeitaufwand';
    xdsKontosaldoAbzurechnen.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoAbzurechnen.Name := 'xdsKontosaldoAbzurechnen';
    xdsKontosaldoAbzurechnen.FieldName := 'Abzurechnen';
    xdsKontosaldoGutschrift.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoGutschrift.Name := 'xdsKontosaldoGutschrift';
    xdsKontosaldoGutschrift.FieldName := 'Gutschrift';
    xdsKontosaldoAbzug.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoAbzug.Name := 'xdsKontosaldoAbzug';
    xdsKontosaldoAbzug.FieldName := 'Abzug';
    xdsKontosaldoSaldo.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoSaldo.Name := 'xdsKontosaldoSaldo';
    xdsKontosaldoSaldo.FieldName := 'Saldo';
    xdsKontosaldoBetrag.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoBetrag.Name := 'xdsKontosaldoBetrag';
    xdsKontosaldoBetrag.FieldName := 'Betrag';
    xdsKontosaldoMinutenpreis.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoMinutenpreis.Name := 'xdsKontosaldoMinutenpreis';
    xdsKontosaldoMinutenpreis.FieldName := 'Minutenpreis';
    xdsKontosaldoSRestguthaben.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoSRestguthaben.Name := 'xdsKontosaldoSRestguthaben';
    xdsKontosaldoSRestguthaben.FieldName := 'SRestguthaben';
    xdsTicket.SetParentComponent(Self);
    xdsTicket.Name := 'xdsTicket';
    xdsTicket.AfterApplyUpdates := xdsTicketAfterApplyUpdates;
    xdsTicket.AfterOpen := xdsTicketAfterOpen;
    xdsTicket.AfterPost := xdsTicketAfterPost;
    xdsTicket.EntitySetName := 'ITS_TicketMain';
    xdsTicket.Connection := DM2.XDataWebConnection1;
    xdsTicket.QueryTop := 1;
    xdsTicket.Left := 32;
    xdsTicket.Top := 360;
    xdsTicketKundennummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummer.Name := 'xdsTicketKundennummer';
    xdsTicketKundennummer.FieldName := 'Kundennummer';
    xdsTicketProdukt.SetParentComponent(xdsTicket);
    xdsTicketProdukt.Name := 'xdsTicketProdukt';
    xdsTicketProdukt.FieldName := 'Produkt';
    xdsTicketKategorie.SetParentComponent(xdsTicket);
    xdsTicketKategorie.Name := 'xdsTicketKategorie';
    xdsTicketKategorie.FieldName := 'Kategorie';
    xdsTicketPrioritaet.SetParentComponent(xdsTicket);
    xdsTicketPrioritaet.Name := 'xdsTicketPrioritaet';
    xdsTicketPrioritaet.FieldName := 'Prioritaet';
    xdsTicketStatus.SetParentComponent(xdsTicket);
    xdsTicketStatus.Name := 'xdsTicketStatus';
    xdsTicketStatus.FieldName := 'Status';
    xdsTicketID.SetParentComponent(xdsTicket);
    xdsTicketID.Name := 'xdsTicketID';
    xdsTicketID.FieldName := 'ID';
    xdsTicketID.Required := True;
    xdsTicketErstelltAm.SetParentComponent(xdsTicket);
    xdsTicketErstelltAm.Name := 'xdsTicketErstelltAm';
    xdsTicketErstelltAm.FieldName := 'ErstelltAm';
    xdsTicketBetreff.SetParentComponent(xdsTicket);
    xdsTicketBetreff.Name := 'xdsTicketBetreff';
    xdsTicketBetreff.FieldName := 'Betreff';
    xdsTicketBetreff.Size := 100;
    xdsTicketBeschreibung.SetParentComponent(xdsTicket);
    xdsTicketBeschreibung.Name := 'xdsTicketBeschreibung';
    xdsTicketBeschreibung.FieldName := 'Beschreibung';
    xdsTicketBeschreibung.Size := 255;
    xdsTicketAbrechnungsbetrag.SetParentComponent(xdsTicket);
    xdsTicketAbrechnungsbetrag.Name := 'xdsTicketAbrechnungsbetrag';
    xdsTicketAbrechnungsbetrag.FieldName := 'Abrechnungsbetrag';
    xdsTicketAbrechnungRechnungsnummer.SetParentComponent(xdsTicket);
    xdsTicketAbrechnungRechnungsnummer.Name := 'xdsTicketAbrechnungRechnungsnummer';
    xdsTicketAbrechnungRechnungsnummer.FieldName := 'AbrechnungRechnungsnummer';
    xdsTicketAbrechnungRechnungsnummer.Size := 10;
    xdsTicketAberechnetAm.SetParentComponent(xdsTicket);
    xdsTicketAberechnetAm.Name := 'xdsTicketAberechnetAm';
    xdsTicketAberechnetAm.FieldName := 'AberechnetAm';
    xdsTicketErledigtAm.SetParentComponent(xdsTicket);
    xdsTicketErledigtAm.Name := 'xdsTicketErledigtAm';
    xdsTicketErledigtAm.FieldName := 'ErledigtAm';
    xdsTicketNachname.SetParentComponent(xdsTicket);
    xdsTicketNachname.Name := 'xdsTicketNachname';
    xdsTicketNachname.FieldName := 'Nachname';
    xdsTicketNachname.Size := 40;
    xdsTicketVorname.SetParentComponent(xdsTicket);
    xdsTicketVorname.Name := 'xdsTicketVorname';
    xdsTicketVorname.FieldName := 'Vorname';
    xdsTicketVorname.Size := 40;
    xdsTicketEmail.SetParentComponent(xdsTicket);
    xdsTicketEmail.Name := 'xdsTicketEmail';
    xdsTicketEmail.FieldName := 'Email';
    xdsTicketEmail.Size := 50;
    xdsTicketSystemInfo.SetParentComponent(xdsTicket);
    xdsTicketSystemInfo.Name := 'xdsTicketSystemInfo';
    xdsTicketSystemInfo.FieldName := 'SystemInfo';
    xdsTicketSystemInfo.Size := 255;
    xdsTicketLoesung.SetParentComponent(xdsTicket);
    xdsTicketLoesung.Name := 'xdsTicketLoesung';
    xdsTicketLoesung.FieldName := 'Loesung';
    xdsTicketLoesung.Size := 255;
    xdsTicketProtokoll.SetParentComponent(xdsTicket);
    xdsTicketProtokoll.Name := 'xdsTicketProtokoll';
    xdsTicketProtokoll.FieldName := 'Protokoll';
    xdsTicketProtokoll.Size := 255;
    xdsTicketZeitaufwandMinuten.SetParentComponent(xdsTicket);
    xdsTicketZeitaufwandMinuten.Name := 'xdsTicketZeitaufwandMinuten';
    xdsTicketZeitaufwandMinuten.FieldName := 'ZeitaufwandMinuten';
    xdsTicketAbzurechnendeMinuten.SetParentComponent(xdsTicket);
    xdsTicketAbzurechnendeMinuten.Name := 'xdsTicketAbzurechnendeMinuten';
    xdsTicketAbzurechnendeMinuten.FieldName := 'AbzurechnendeMinuten';
    xdsTicketAbgerechneteMinuten.SetParentComponent(xdsTicket);
    xdsTicketAbgerechneteMinuten.Name := 'xdsTicketAbgerechneteMinuten';
    xdsTicketAbgerechneteMinuten.FieldName := 'AbgerechneteMinuten';
    xdsTicketBenachrichtigungNEU.SetParentComponent(xdsTicket);
    xdsTicketBenachrichtigungNEU.Name := 'xdsTicketBenachrichtigungNEU';
    xdsTicketBenachrichtigungNEU.FieldName := 'BenachrichtigungNEU';
    xdsTicketBenachrichtigungLoesung.SetParentComponent(xdsTicket);
    xdsTicketBenachrichtigungLoesung.Name := 'xdsTicketBenachrichtigungLoesung';
    xdsTicketBenachrichtigungLoesung.FieldName := 'BenachrichtigungLoesung';
    xdsTicketInterneBemerkung.SetParentComponent(xdsTicket);
    xdsTicketInterneBemerkung.Name := 'xdsTicketInterneBemerkung';
    xdsTicketInterneBemerkung.FieldName := 'InterneBemerkung';
    xdsTicketInterneBemerkung.Size := 255;
    xdsTicketLoesungInfoSenden.SetParentComponent(xdsTicket);
    xdsTicketLoesungInfoSenden.Name := 'xdsTicketLoesungInfoSenden';
    xdsTicketLoesungInfoSenden.FieldName := 'LoesungInfoSenden';
    xdsTicketKontaktperson.SetParentComponent(xdsTicket);
    xdsTicketKontaktperson.Name := 'xdsTicketKontaktperson';
    xdsTicketKontaktperson.FieldName := 'Kontaktperson';
    xdsTicketKontaktperson.Size := 100;
    xdsTicketErreichbarkeitTelefon.SetParentComponent(xdsTicket);
    xdsTicketErreichbarkeitTelefon.Name := 'xdsTicketErreichbarkeitTelefon';
    xdsTicketErreichbarkeitTelefon.FieldName := 'ErreichbarkeitTelefon';
    xdsTicketErreichbarkeitTelefon.Size := 100;
    xdsTicketErreichbarkeitWann.SetParentComponent(xdsTicket);
    xdsTicketErreichbarkeitWann.Name := 'xdsTicketErreichbarkeitWann';
    xdsTicketErreichbarkeitWann.FieldName := 'ErreichbarkeitWann';
    xdsTicketErreichbarkeitWann.Size := 100;
    xdsTicketKontaktpersonEmail.SetParentComponent(xdsTicket);
    xdsTicketKontaktpersonEmail.Name := 'xdsTicketKontaktpersonEmail';
    xdsTicketKontaktpersonEmail.FieldName := 'KontaktpersonEmail';
    xdsTicketKontaktpersonEmail.Size := 100;
    xdsProdukte.SetParentComponent(Self);
    xdsProdukte.Name := 'xdsProdukte';
    xdsProdukte.AfterOpen := xdsProdukteAfterOpen;
    xdsProdukte.EntitySetName := 'ITS_Produkte';
    xdsProdukte.Connection := DM2.XDataWebConnection1;
    xdsProdukte.Left := 32;
    xdsProdukte.Top := 416;
    xdsProdukteProdukt.SetParentComponent(xdsProdukte);
    xdsProdukteProdukt.Name := 'xdsProdukteProdukt';
    xdsProdukteProdukt.FieldName := 'Produkt';
    xdsProdukteProdukt.Required := True;
    xdsProdukteProdukt.Size := 50;
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 32;
    xdsKundendaten.Top := 232;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Required := True;
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenGruppeKunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeKunden.Name := 'xdsKundendatenGruppeKunden';
    xdsKundendatenGruppeKunden.FieldName := 'GruppeKunden';
    xdsKundendatenGruppeLieferanten.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeLieferanten.Name := 'xdsKundendatenGruppeLieferanten';
    xdsKundendatenGruppeLieferanten.FieldName := 'GruppeLieferanten';
    xdsKundendatenGruppeSonstige.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeSonstige.Name := 'xdsKundendatenGruppeSonstige';
    xdsKundendatenGruppeSonstige.FieldName := 'GruppeSonstige';
    xdsKundendatenGruppeNichtkunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeNichtkunden.Name := 'xdsKundendatenGruppeNichtkunden';
    xdsKundendatenGruppeNichtkunden.FieldName := 'GruppeNichtkunden';
    xdsKundendatenKontaktgruppe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktgruppe.Name := 'xdsKundendatenKontaktgruppe';
    xdsKundendatenKontaktgruppe.FieldName := 'Kontaktgruppe';
    xdsKundendatenKontaktgruppe.Size := 50;
    xdsKundendatenNachname.SetParentComponent(xdsKundendaten);
    xdsKundendatenNachname.Name := 'xdsKundendatenNachname';
    xdsKundendatenNachname.FieldName := 'Nachname';
    xdsKundendatenNachname.Size := 40;
    xdsKundendatenVorname.SetParentComponent(xdsKundendaten);
    xdsKundendatenVorname.Name := 'xdsKundendatenVorname';
    xdsKundendatenVorname.FieldName := 'Vorname';
    xdsKundendatenVorname.Size := 40;
    xdsKundendatenAdresszeile2.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile2.Name := 'xdsKundendatenAdresszeile2';
    xdsKundendatenAdresszeile2.FieldName := 'Adresszeile2';
    xdsKundendatenAdresszeile2.Size := 40;
    xdsKundendatenAdresszeile3.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile3.Name := 'xdsKundendatenAdresszeile3';
    xdsKundendatenAdresszeile3.FieldName := 'Adresszeile3';
    xdsKundendatenAdresszeile3.Size := 40;
    xdsKundendatenStrasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenStrasse.Name := 'xdsKundendatenStrasse';
    xdsKundendatenStrasse.FieldName := 'Strasse';
    xdsKundendatenStrasse.Size := 40;
    xdsKundendatenPostleitzahl.SetParentComponent(xdsKundendaten);
    xdsKundendatenPostleitzahl.Name := 'xdsKundendatenPostleitzahl';
    xdsKundendatenPostleitzahl.FieldName := 'Postleitzahl';
    xdsKundendatenPostleitzahl.Size := 6;
    xdsKundendatenOrt.SetParentComponent(xdsKundendaten);
    xdsKundendatenOrt.Name := 'xdsKundendatenOrt';
    xdsKundendatenOrt.FieldName := 'Ort';
    xdsKundendatenOrt.Size := 40;
    xdsKundendatenLaenderkuerzel.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkuerzel.Name := 'xdsKundendatenLaenderkuerzel';
    xdsKundendatenLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsKundendatenLaenderkuerzel.Size := 5;
    xdsKundendatenLand.SetParentComponent(xdsKundendaten);
    xdsKundendatenLand.Name := 'xdsKundendatenLand';
    xdsKundendatenLand.FieldName := 'Land';
    xdsKundendatenLand.Size := 40;
    xdsKundendatenLaenderkennzeichen.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkennzeichen.Name := 'xdsKundendatenLaenderkennzeichen';
    xdsKundendatenLaenderkennzeichen.FieldName := 'Laenderkennzeichen';
    xdsKundendatenAdressanrede.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdressanrede.Name := 'xdsKundendatenAdressanrede';
    xdsKundendatenAdressanrede.FieldName := 'Adressanrede';
    xdsKundendatenAdressanrede.Size := 15;
    xdsKundendatenBriefanrede1.SetParentComponent(xdsKundendaten);
    xdsKundendatenBriefanrede1.Name := 'xdsKundendatenBriefanrede1';
    xdsKundendatenBriefanrede1.FieldName := 'Briefanrede1';
    xdsKundendatenBriefanrede1.Size := 255;
    xdsKundendatenAdresseBild.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresseBild.Name := 'xdsKundendatenAdresseBild';
    xdsKundendatenAdresseBild.FieldName := 'AdresseBild';
    xdsKundendatenAdresseBild.Size := 255;
    xdsKundendatenLieferanschrift.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschrift.Name := 'xdsKundendatenLieferanschrift';
    xdsKundendatenLieferanschrift.FieldName := 'Lieferanschrift';
    xdsKundendatenLieferanschrift.Size := 255;
    xdsKundendatenTelefonNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonNummer.Name := 'xdsKundendatenTelefonNummer';
    xdsKundendatenTelefonNummer.FieldName := 'TelefonNummer';
    xdsKundendatenTelefonNummer.Size := 25;
    xdsKundendatenTelefaxNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefaxNummer.Name := 'xdsKundendatenTelefaxNummer';
    xdsKundendatenTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsKundendatenTelefaxNummer.Size := 25;
    xdsKundendatenMobilTelefon.SetParentComponent(xdsKundendaten);
    xdsKundendatenMobilTelefon.Name := 'xdsKundendatenMobilTelefon';
    xdsKundendatenMobilTelefon.FieldName := 'MobilTelefon';
    xdsKundendatenMobilTelefon.Size := 25;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenInternet.SetParentComponent(xdsKundendaten);
    xdsKundendatenInternet.Name := 'xdsKundendatenInternet';
    xdsKundendatenInternet.FieldName := 'Internet';
    xdsKundendatenInternet.Size := 50;
    xdsKundendatenUmsatzsteuerID.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerID.Name := 'xdsKundendatenUmsatzsteuerID';
    xdsKundendatenUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsKundendatenUmsatzsteuerausweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerausweis.Name := 'xdsKundendatenUmsatzsteuerausweis';
    xdsKundendatenUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsKundendatenZahlungsbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenZahlungsbedingung.Name := 'xdsKundendatenZahlungsbedingung';
    xdsKundendatenZahlungsbedingung.FieldName := 'Zahlungsbedingung';
    xdsKundendatenTransportbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenTransportbedingung.Name := 'xdsKundendatenTransportbedingung';
    xdsKundendatenTransportbedingung.FieldName := 'Transportbedingung';
    xdsKundendatenTransportbedingung.Size := 100;
    xdsKundendatenKeinNewsletter.SetParentComponent(xdsKundendaten);
    xdsKundendatenKeinNewsletter.Name := 'xdsKundendatenKeinNewsletter';
    xdsKundendatenKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsKundendatenTelefonAlternativ.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonAlternativ.Name := 'xdsKundendatenTelefonAlternativ';
    xdsKundendatenTelefonAlternativ.FieldName := 'TelefonAlternativ';
    xdsKundendatenTelefonAlternativ.Size := 50;
    xdsKundendatenTitel.SetParentComponent(xdsKundendaten);
    xdsKundendatenTitel.Name := 'xdsKundendatenTitel';
    xdsKundendatenTitel.FieldName := 'Titel';
    xdsKundendatenKundenklasseFarbe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundenklasseFarbe.Name := 'xdsKundendatenKundenklasseFarbe';
    xdsKundendatenKundenklasseFarbe.FieldName := 'KundenklasseFarbe';
    xdsKundendatenRechnungEmail.SetParentComponent(xdsKundendaten);
    xdsKundendatenRechnungEmail.Name := 'xdsKundendatenRechnungEmail';
    xdsKundendatenRechnungEmail.FieldName := 'RechnungEmail';
    xdsKundendatenRechnungEmail.Size := 50;
    xdsKundendatenLoginPW.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginPW.Name := 'xdsKundendatenLoginPW';
    xdsKundendatenLoginPW.FieldName := 'LoginPW';
    xdsKundendatenBesteuerungKey.SetParentComponent(xdsKundendaten);
    xdsKundendatenBesteuerungKey.Name := 'xdsKundendatenBesteuerungKey';
    xdsKundendatenBesteuerungKey.FieldName := 'BesteuerungKey';
    xdsKundendatenAuftraegeJahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeJahr.Name := 'xdsKundendatenAuftraegeJahr';
    xdsKundendatenAuftraegeJahr.FieldName := 'AuftraegeJahr';
    xdsKundendatenAuftraegeVorjahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeVorjahr.Name := 'xdsKundendatenAuftraegeVorjahr';
    xdsKundendatenAuftraegeVorjahr.FieldName := 'AuftraegeVorjahr';
    xdsKundendatenLieferadresseID.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferadresseID.Name := 'xdsKundendatenLieferadresseID';
    xdsKundendatenLieferadresseID.FieldName := 'LieferadresseID';
    xdsKundendatenUSTIDgeprueft.SetParentComponent(xdsKundendaten);
    xdsKundendatenUSTIDgeprueft.Name := 'xdsKundendatenUSTIDgeprueft';
    xdsKundendatenUSTIDgeprueft.FieldName := 'USTIDgeprueft';
    xdsKundendatenKontaktverbund.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktverbund.Name := 'xdsKundendatenKontaktverbund';
    xdsKundendatenKontaktverbund.FieldName := 'Kontaktverbund';
    xdsKundendatenKontaktverbund.Size := 25;
    xdsKundendatenHinweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenHinweis.Name := 'xdsKundendatenHinweis';
    xdsKundendatenHinweis.FieldName := 'Hinweis';
    xdsKundendatenHinweis.Size := 255;
    xdsKundendatenLatitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLatitude.Name := 'xdsKundendatenLatitude';
    xdsKundendatenLatitude.FieldName := 'Latitude';
    xdsKundendatenLongitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLongitude.Name := 'xdsKundendatenLongitude';
    xdsKundendatenLongitude.FieldName := 'Longitude';
    xdsKundendatenkmLuftlinie.SetParentComponent(xdsKundendaten);
    xdsKundendatenkmLuftlinie.Name := 'xdsKundendatenkmLuftlinie';
    xdsKundendatenkmLuftlinie.FieldName := 'kmLuftlinie';
    xdsKundendatenGoogleID.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleID.Name := 'xdsKundendatenGoogleID';
    xdsKundendatenGoogleID.FieldName := 'GoogleID';
    xdsKundendatenGoogleID.Size := 50;
    xdsKundendatenGoogleUpdatedUTC.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleUpdatedUTC.Name := 'xdsKundendatenGoogleUpdatedUTC';
    xdsKundendatenGoogleUpdatedUTC.FieldName := 'GoogleUpdatedUTC';
    xdsKundendatenBundesland.SetParentComponent(xdsKundendaten);
    xdsKundendatenBundesland.Name := 'xdsKundendatenBundesland';
    xdsKundendatenBundesland.FieldName := 'Bundesland';
    xdsKundendatenBundesland.Size := 50;
    xdsKundendatenRegion.SetParentComponent(xdsKundendaten);
    xdsKundendatenRegion.Name := 'xdsKundendatenRegion';
    xdsKundendatenRegion.FieldName := 'Region';
    xdsKundendatenRegion.Size := 50;
    xdsKundendatenMandatsreferenz.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenz.Name := 'xdsKundendatenMandatsreferenz';
    xdsKundendatenMandatsreferenz.FieldName := 'Mandatsreferenz';
    xdsKundendatenMandatsreferenz.Size := 34;
    xdsKundendatenMandatsreferenzVom.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenzVom.Name := 'xdsKundendatenMandatsreferenzVom';
    xdsKundendatenMandatsreferenzVom.FieldName := 'MandatsreferenzVom';
    xdsKundendatenLastschriftArt.SetParentComponent(xdsKundendaten);
    xdsKundendatenLastschriftArt.Name := 'xdsKundendatenLastschriftArt';
    xdsKundendatenLastschriftArt.FieldName := 'LastschriftArt';
    xdsKundendatenLastschriftArt.Size := 2;
    xdsKundendatenMahnsperre.SetParentComponent(xdsKundendaten);
    xdsKundendatenMahnsperre.Name := 'xdsKundendatenMahnsperre';
    xdsKundendatenMahnsperre.FieldName := 'Mahnsperre';
    xdsKundendatenSuchbegriff.SetParentComponent(xdsKundendaten);
    xdsKundendatenSuchbegriff.Name := 'xdsKundendatenSuchbegriff';
    xdsKundendatenSuchbegriff.FieldName := 'Suchbegriff';
    xdsKundendatenSuchbegriff.Size := 25;
    xdsKundendatenLieferanschriftDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschriftDaten.Name := 'xdsKundendatenLieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.FieldName := 'LieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.Size := 255;
    xdsKundendatenExportKasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenExportKasse.Name := 'xdsKundendatenExportKasse';
    xdsKundendatenExportKasse.FieldName := 'ExportKasse';
    xdsKundendatenLoeschvormerkungDatum.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungDatum.Name := 'xdsKundendatenLoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungDatum.FieldName := 'LoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungGrund.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungGrund.Name := 'xdsKundendatenLoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.FieldName := 'LoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.Size := 250;
    xdsKundendatenPseudonymisiert.SetParentComponent(xdsKundendaten);
    xdsKundendatenPseudonymisiert.Name := 'xdsKundendatenPseudonymisiert';
    xdsKundendatenPseudonymisiert.FieldName := 'Pseudonymisiert';
    xdsKundendatenPseudonymisiert.Size := 255;
    xdsKundendatenLoginAktiv.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginAktiv.Name := 'xdsKundendatenLoginAktiv';
    xdsKundendatenLoginAktiv.FieldName := 'LoginAktiv';
    xdsKundendatenSonstigeDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenSonstigeDaten.Name := 'xdsKundendatenSonstigeDaten';
    xdsKundendatenSonstigeDaten.FieldName := 'SonstigeDaten';
    xdsKundendatenSonstigeDaten.Size := 255;
    xdsStatus.SetParentComponent(Self);
    xdsStatus.Name := 'xdsStatus';
    xdsStatus.AfterOpen := xdsStatusAfterOpen;
    xdsStatus.EntitySetName := 'ITS_TicketStatus';
    xdsStatus.Connection := DM2.XDataWebConnection1;
    xdsStatus.Left := 32;
    xdsStatus.Top := 168;
    xdsStatusStatus.SetParentComponent(xdsStatus);
    xdsStatusStatus.Name := 'xdsStatusStatus';
    xdsStatusStatus.FieldName := 'Status';
    xdsStatusStatus.Required := True;
    xdsStatusStatus.Size := 25;
    xdsKategorie.SetParentComponent(Self);
    xdsKategorie.Name := 'xdsKategorie';
    xdsKategorie.AfterOpen := xdsKategorieAfterOpen;
    xdsKategorie.EntitySetName := 'ITS_TicketKategorie';
    xdsKategorie.Connection := DM2.XDataWebConnection1;
    xdsKategorie.Left := 32;
    xdsKategorie.Top := 112;
    xdsKategorieKategorie.SetParentComponent(xdsKategorie);
    xdsKategorieKategorie.Name := 'xdsKategorieKategorie';
    xdsKategorieKategorie.FieldName := 'Kategorie';
    xdsKategorieKategorie.Required := True;
    xdsKategorieKategorie.Size := 25;
    xdsprioritaet.SetParentComponent(Self);
    xdsprioritaet.Name := 'xdsprioritaet';
    xdsprioritaet.AfterOpen := xdsprioritaetAfterOpen;
    xdsprioritaet.EntitySetName := 'ITS_TicketPrioritaet';
    xdsprioritaet.Connection := DM2.XDataWebConnection1;
    xdsprioritaet.QueryString := '$filter=Prioritaet gt 0';
    xdsprioritaet.Left := 32;
    xdsprioritaet.Top := 56;
    xdsprioritaetPrioritaet.SetParentComponent(xdsprioritaet);
    xdsprioritaetPrioritaet.Name := 'xdsprioritaetPrioritaet';
    xdsprioritaetPrioritaet.FieldName := 'Prioritaet';
    xdsprioritaetPrioritaet.Required := True;
    xdsprioritaetPrioText.SetParentComponent(xdsprioritaet);
    xdsprioritaetPrioText.Name := 'xdsprioritaetPrioText';
    xdsprioritaetPrioText.FieldName := 'PrioText';
    xdsprioritaetPrioFarbe.SetParentComponent(xdsprioritaet);
    xdsprioritaetPrioFarbe.Name := 'xdsprioritaetPrioFarbe';
    xdsprioritaetPrioFarbe.FieldName := 'PrioFarbe';
    xdsTicketDateien.SetParentComponent(Self);
    xdsTicketDateien.Name := 'xdsTicketDateien';
    xdsTicketDateien.AfterApplyUpdates := xdsTicketDateienAfterApplyUpdates;
    xdsTicketDateien.AfterOpen := xdsTicketDateienAfterOpen;
    SetEvent(xdsTicketDateien, Self, 'OnNewRecord', 'xdsTicketDateienNewRecord');
    xdsTicketDateien.EntitySetName := 'ITS_TicketDateien';
    xdsTicketDateien.Connection := DM2.XDataWebConnection1;
    xdsTicketDateien.QueryTop := 1;
    xdsTicketDateien.Left := 128;
    xdsTicketDateien.Top := 56;
    xdsTicketDateienTicketID.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienTicketID.Name := 'xdsTicketDateienTicketID';
    xdsTicketDateienTicketID.FieldName := 'TicketID';
    xdsTicketDateienTicketID.Required := True;
    xdsTicketDateienID.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienID.Name := 'xdsTicketDateienID';
    xdsTicketDateienID.FieldName := 'ID';
    xdsTicketDateienID.Required := True;
    xdsTicketDateienDatumUhrzeit.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDatumUhrzeit.Name := 'xdsTicketDateienDatumUhrzeit';
    xdsTicketDateienDatumUhrzeit.FieldName := 'DatumUhrzeit';
    xdsTicketDateienDatumUhrzeit.Required := True;
    xdsTicketDateienFuerLoesung.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienFuerLoesung.Name := 'xdsTicketDateienFuerLoesung';
    xdsTicketDateienFuerLoesung.FieldName := 'FuerLoesung';
    xdsTicketDateienDateiMime.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiMime.Name := 'xdsTicketDateienDateiMime';
    xdsTicketDateienDateiMime.FieldName := 'DateiMime';
    xdsTicketDateienDateiMime.Size := 50;
    xdsTicketDateienDateiName.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiName.Name := 'xdsTicketDateienDateiName';
    xdsTicketDateienDateiName.FieldName := 'DateiName';
    xdsTicketDateienDateiName.Size := 255;
    xdsTicketDateienDateiGroesse.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiGroesse.Name := 'xdsTicketDateienDateiGroesse';
    xdsTicketDateienDateiGroesse.FieldName := 'DateiGroesse';
    xdsTicketDateienDateiInhaltText.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiInhaltText.Name := 'xdsTicketDateienDateiInhaltText';
    xdsTicketDateienDateiInhaltText.FieldName := 'DateiInhaltText';
    xdsTicketDateienDateiInhaltText.Size := 255;
    xdsticket2.SetParentComponent(Self);
    xdsticket2.Name := 'xdsticket2';
    xdsticket2.AfterOpen := xdsticket2AfterOpen;
    xdsticket2.EntitySetName := 'ITS_TicketMain';
    xdsticket2.Connection := DM2.XDataWebConnection1;
    xdsticket2.QueryString := '$orderby=ID DESC';
    xdsticket2.QueryTop := 1;
    xdsticket2.Left := 136;
    xdsticket2.Top := 360;
    xdsticket2Kundennummer.SetParentComponent(xdsticket2);
    xdsticket2Kundennummer.Name := 'xdsticket2Kundennummer';
    xdsticket2Kundennummer.FieldName := 'Kundennummer';
    xdsticket2Produkt.SetParentComponent(xdsticket2);
    xdsticket2Produkt.Name := 'xdsticket2Produkt';
    xdsticket2Produkt.FieldName := 'Produkt';
    xdsticket2Kategorie.SetParentComponent(xdsticket2);
    xdsticket2Kategorie.Name := 'xdsticket2Kategorie';
    xdsticket2Kategorie.FieldName := 'Kategorie';
    xdsticket2Prioritaet.SetParentComponent(xdsticket2);
    xdsticket2Prioritaet.Name := 'xdsticket2Prioritaet';
    xdsticket2Prioritaet.FieldName := 'Prioritaet';
    xdsticket2Status.SetParentComponent(xdsticket2);
    xdsticket2Status.Name := 'xdsticket2Status';
    xdsticket2Status.FieldName := 'Status';
    xdsticket2ID.SetParentComponent(xdsticket2);
    xdsticket2ID.Name := 'xdsticket2ID';
    xdsticket2ID.FieldName := 'ID';
    xdsticket2ID.Required := True;
    xdsticket2ErstelltAm.SetParentComponent(xdsticket2);
    xdsticket2ErstelltAm.Name := 'xdsticket2ErstelltAm';
    xdsticket2ErstelltAm.FieldName := 'ErstelltAm';
    xdsticket2Betreff.SetParentComponent(xdsticket2);
    xdsticket2Betreff.Name := 'xdsticket2Betreff';
    xdsticket2Betreff.FieldName := 'Betreff';
    xdsticket2Betreff.Size := 100;
    xdsticket2Beschreibung.SetParentComponent(xdsticket2);
    xdsticket2Beschreibung.Name := 'xdsticket2Beschreibung';
    xdsticket2Beschreibung.FieldName := 'Beschreibung';
    xdsticket2Beschreibung.Size := 255;
    xdsticket2Abrechnungsbetrag.SetParentComponent(xdsticket2);
    xdsticket2Abrechnungsbetrag.Name := 'xdsticket2Abrechnungsbetrag';
    xdsticket2Abrechnungsbetrag.FieldName := 'Abrechnungsbetrag';
    xdsticket2AbrechnungRechnungsnummer.SetParentComponent(xdsticket2);
    xdsticket2AbrechnungRechnungsnummer.Name := 'xdsticket2AbrechnungRechnungsnummer';
    xdsticket2AbrechnungRechnungsnummer.FieldName := 'AbrechnungRechnungsnummer';
    xdsticket2AbrechnungRechnungsnummer.Size := 10;
    xdsticket2AberechnetAm.SetParentComponent(xdsticket2);
    xdsticket2AberechnetAm.Name := 'xdsticket2AberechnetAm';
    xdsticket2AberechnetAm.FieldName := 'AberechnetAm';
    xdsticket2ErledigtAm.SetParentComponent(xdsticket2);
    xdsticket2ErledigtAm.Name := 'xdsticket2ErledigtAm';
    xdsticket2ErledigtAm.FieldName := 'ErledigtAm';
    xdsticket2Nachname.SetParentComponent(xdsticket2);
    xdsticket2Nachname.Name := 'xdsticket2Nachname';
    xdsticket2Nachname.FieldName := 'Nachname';
    xdsticket2Nachname.Size := 40;
    xdsticket2Vorname.SetParentComponent(xdsticket2);
    xdsticket2Vorname.Name := 'xdsticket2Vorname';
    xdsticket2Vorname.FieldName := 'Vorname';
    xdsticket2Vorname.Size := 40;
    xdsticket2Email.SetParentComponent(xdsticket2);
    xdsticket2Email.Name := 'xdsticket2Email';
    xdsticket2Email.FieldName := 'Email';
    xdsticket2Email.Size := 50;
    xdsticket2SystemInfo.SetParentComponent(xdsticket2);
    xdsticket2SystemInfo.Name := 'xdsticket2SystemInfo';
    xdsticket2SystemInfo.FieldName := 'SystemInfo';
    xdsticket2SystemInfo.Size := 255;
    xdsticket2Loesung.SetParentComponent(xdsticket2);
    xdsticket2Loesung.Name := 'xdsticket2Loesung';
    xdsticket2Loesung.FieldName := 'Loesung';
    xdsticket2Loesung.Size := 255;
    xdsticket2Protokoll.SetParentComponent(xdsticket2);
    xdsticket2Protokoll.Name := 'xdsticket2Protokoll';
    xdsticket2Protokoll.FieldName := 'Protokoll';
    xdsticket2Protokoll.Size := 255;
    xdsticket2ZeitaufwandMinuten.SetParentComponent(xdsticket2);
    xdsticket2ZeitaufwandMinuten.Name := 'xdsticket2ZeitaufwandMinuten';
    xdsticket2ZeitaufwandMinuten.FieldName := 'ZeitaufwandMinuten';
    xdsticket2AbzurechnendeMinuten.SetParentComponent(xdsticket2);
    xdsticket2AbzurechnendeMinuten.Name := 'xdsticket2AbzurechnendeMinuten';
    xdsticket2AbzurechnendeMinuten.FieldName := 'AbzurechnendeMinuten';
    xdsticket2AbgerechneteMinuten.SetParentComponent(xdsticket2);
    xdsticket2AbgerechneteMinuten.Name := 'xdsticket2AbgerechneteMinuten';
    xdsticket2AbgerechneteMinuten.FieldName := 'AbgerechneteMinuten';
    xdsticket2BenachrichtigungNEU.SetParentComponent(xdsticket2);
    xdsticket2BenachrichtigungNEU.Name := 'xdsticket2BenachrichtigungNEU';
    xdsticket2BenachrichtigungNEU.FieldName := 'BenachrichtigungNEU';
    xdsticket2BenachrichtigungLoesung.SetParentComponent(xdsticket2);
    xdsticket2BenachrichtigungLoesung.Name := 'xdsticket2BenachrichtigungLoesung';
    xdsticket2BenachrichtigungLoesung.FieldName := 'BenachrichtigungLoesung';
    xdsticket2InterneBemerkung.SetParentComponent(xdsticket2);
    xdsticket2InterneBemerkung.Name := 'xdsticket2InterneBemerkung';
    xdsticket2InterneBemerkung.FieldName := 'InterneBemerkung';
    xdsticket2InterneBemerkung.Size := 255;
    xdsticket2LoesungInfoSenden.SetParentComponent(xdsticket2);
    xdsticket2LoesungInfoSenden.Name := 'xdsticket2LoesungInfoSenden';
    xdsticket2LoesungInfoSenden.FieldName := 'LoesungInfoSenden';
    xdsticket2Kontaktperson.SetParentComponent(xdsticket2);
    xdsticket2Kontaktperson.Name := 'xdsticket2Kontaktperson';
    xdsticket2Kontaktperson.FieldName := 'Kontaktperson';
    xdsticket2Kontaktperson.Size := 100;
    xdsticket2KontaktpersonEmail.SetParentComponent(xdsticket2);
    xdsticket2KontaktpersonEmail.Name := 'xdsticket2KontaktpersonEmail';
    xdsticket2KontaktpersonEmail.FieldName := 'KontaktpersonEmail';
    xdsticket2KontaktpersonEmail.Size := 100;
    xdsticket2ErreichbarkeitTelefon.SetParentComponent(xdsticket2);
    xdsticket2ErreichbarkeitTelefon.Name := 'xdsticket2ErreichbarkeitTelefon';
    xdsticket2ErreichbarkeitTelefon.FieldName := 'ErreichbarkeitTelefon';
    xdsticket2ErreichbarkeitTelefon.Size := 100;
    xdsticket2ErreichbarkeitWann.SetParentComponent(xdsticket2);
    xdsticket2ErreichbarkeitWann.Name := 'xdsticket2ErreichbarkeitWann';
    xdsticket2ErreichbarkeitWann.FieldName := 'ErreichbarkeitWann';
    xdsticket2ErreichbarkeitWann.Size := 100;
  finally
    TC.AfterLoadDFMValues;
    WebFilePicker1.AfterLoadDFMValues;
    WebFilePicker2.AfterLoadDFMValues;
    WebFilePicker3.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    PanelTop.AfterLoadDFMValues;
    lblSeite.AfterLoadDFMValues;
    panelfunctions.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    xdsKontosaldo.AfterLoadDFMValues;
    xdsKontosaldoKundennummer.AfterLoadDFMValues;
    xdsKontosaldoZeitaufwand.AfterLoadDFMValues;
    xdsKontosaldoAbzurechnen.AfterLoadDFMValues;
    xdsKontosaldoGutschrift.AfterLoadDFMValues;
    xdsKontosaldoAbzug.AfterLoadDFMValues;
    xdsKontosaldoSaldo.AfterLoadDFMValues;
    xdsKontosaldoBetrag.AfterLoadDFMValues;
    xdsKontosaldoMinutenpreis.AfterLoadDFMValues;
    xdsKontosaldoSRestguthaben.AfterLoadDFMValues;
    xdsTicket.AfterLoadDFMValues;
    xdsTicketKundennummer.AfterLoadDFMValues;
    xdsTicketProdukt.AfterLoadDFMValues;
    xdsTicketKategorie.AfterLoadDFMValues;
    xdsTicketPrioritaet.AfterLoadDFMValues;
    xdsTicketStatus.AfterLoadDFMValues;
    xdsTicketID.AfterLoadDFMValues;
    xdsTicketErstelltAm.AfterLoadDFMValues;
    xdsTicketBetreff.AfterLoadDFMValues;
    xdsTicketBeschreibung.AfterLoadDFMValues;
    xdsTicketAbrechnungsbetrag.AfterLoadDFMValues;
    xdsTicketAbrechnungRechnungsnummer.AfterLoadDFMValues;
    xdsTicketAberechnetAm.AfterLoadDFMValues;
    xdsTicketErledigtAm.AfterLoadDFMValues;
    xdsTicketNachname.AfterLoadDFMValues;
    xdsTicketVorname.AfterLoadDFMValues;
    xdsTicketEmail.AfterLoadDFMValues;
    xdsTicketSystemInfo.AfterLoadDFMValues;
    xdsTicketLoesung.AfterLoadDFMValues;
    xdsTicketProtokoll.AfterLoadDFMValues;
    xdsTicketZeitaufwandMinuten.AfterLoadDFMValues;
    xdsTicketAbzurechnendeMinuten.AfterLoadDFMValues;
    xdsTicketAbgerechneteMinuten.AfterLoadDFMValues;
    xdsTicketBenachrichtigungNEU.AfterLoadDFMValues;
    xdsTicketBenachrichtigungLoesung.AfterLoadDFMValues;
    xdsTicketInterneBemerkung.AfterLoadDFMValues;
    xdsTicketLoesungInfoSenden.AfterLoadDFMValues;
    xdsTicketKontaktperson.AfterLoadDFMValues;
    xdsTicketErreichbarkeitTelefon.AfterLoadDFMValues;
    xdsTicketErreichbarkeitWann.AfterLoadDFMValues;
    xdsTicketKontaktpersonEmail.AfterLoadDFMValues;
    xdsProdukte.AfterLoadDFMValues;
    xdsProdukteProdukt.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenGruppeKunden.AfterLoadDFMValues;
    xdsKundendatenGruppeLieferanten.AfterLoadDFMValues;
    xdsKundendatenGruppeSonstige.AfterLoadDFMValues;
    xdsKundendatenGruppeNichtkunden.AfterLoadDFMValues;
    xdsKundendatenKontaktgruppe.AfterLoadDFMValues;
    xdsKundendatenNachname.AfterLoadDFMValues;
    xdsKundendatenVorname.AfterLoadDFMValues;
    xdsKundendatenAdresszeile2.AfterLoadDFMValues;
    xdsKundendatenAdresszeile3.AfterLoadDFMValues;
    xdsKundendatenStrasse.AfterLoadDFMValues;
    xdsKundendatenPostleitzahl.AfterLoadDFMValues;
    xdsKundendatenOrt.AfterLoadDFMValues;
    xdsKundendatenLaenderkuerzel.AfterLoadDFMValues;
    xdsKundendatenLand.AfterLoadDFMValues;
    xdsKundendatenLaenderkennzeichen.AfterLoadDFMValues;
    xdsKundendatenAdressanrede.AfterLoadDFMValues;
    xdsKundendatenBriefanrede1.AfterLoadDFMValues;
    xdsKundendatenAdresseBild.AfterLoadDFMValues;
    xdsKundendatenLieferanschrift.AfterLoadDFMValues;
    xdsKundendatenTelefonNummer.AfterLoadDFMValues;
    xdsKundendatenTelefaxNummer.AfterLoadDFMValues;
    xdsKundendatenMobilTelefon.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenInternet.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerID.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsKundendatenZahlungsbedingung.AfterLoadDFMValues;
    xdsKundendatenTransportbedingung.AfterLoadDFMValues;
    xdsKundendatenKeinNewsletter.AfterLoadDFMValues;
    xdsKundendatenTelefonAlternativ.AfterLoadDFMValues;
    xdsKundendatenTitel.AfterLoadDFMValues;
    xdsKundendatenKundenklasseFarbe.AfterLoadDFMValues;
    xdsKundendatenRechnungEmail.AfterLoadDFMValues;
    xdsKundendatenLoginPW.AfterLoadDFMValues;
    xdsKundendatenBesteuerungKey.AfterLoadDFMValues;
    xdsKundendatenAuftraegeJahr.AfterLoadDFMValues;
    xdsKundendatenAuftraegeVorjahr.AfterLoadDFMValues;
    xdsKundendatenLieferadresseID.AfterLoadDFMValues;
    xdsKundendatenUSTIDgeprueft.AfterLoadDFMValues;
    xdsKundendatenKontaktverbund.AfterLoadDFMValues;
    xdsKundendatenHinweis.AfterLoadDFMValues;
    xdsKundendatenLatitude.AfterLoadDFMValues;
    xdsKundendatenLongitude.AfterLoadDFMValues;
    xdsKundendatenkmLuftlinie.AfterLoadDFMValues;
    xdsKundendatenGoogleID.AfterLoadDFMValues;
    xdsKundendatenGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsKundendatenBundesland.AfterLoadDFMValues;
    xdsKundendatenRegion.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenz.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenzVom.AfterLoadDFMValues;
    xdsKundendatenLastschriftArt.AfterLoadDFMValues;
    xdsKundendatenMahnsperre.AfterLoadDFMValues;
    xdsKundendatenSuchbegriff.AfterLoadDFMValues;
    xdsKundendatenLieferanschriftDaten.AfterLoadDFMValues;
    xdsKundendatenExportKasse.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungDatum.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungGrund.AfterLoadDFMValues;
    xdsKundendatenPseudonymisiert.AfterLoadDFMValues;
    xdsKundendatenLoginAktiv.AfterLoadDFMValues;
    xdsKundendatenSonstigeDaten.AfterLoadDFMValues;
    xdsStatus.AfterLoadDFMValues;
    xdsStatusStatus.AfterLoadDFMValues;
    xdsKategorie.AfterLoadDFMValues;
    xdsKategorieKategorie.AfterLoadDFMValues;
    xdsprioritaet.AfterLoadDFMValues;
    xdsprioritaetPrioritaet.AfterLoadDFMValues;
    xdsprioritaetPrioText.AfterLoadDFMValues;
    xdsprioritaetPrioFarbe.AfterLoadDFMValues;
    xdsTicketDateien.AfterLoadDFMValues;
    xdsTicketDateienTicketID.AfterLoadDFMValues;
    xdsTicketDateienID.AfterLoadDFMValues;
    xdsTicketDateienDatumUhrzeit.AfterLoadDFMValues;
    xdsTicketDateienFuerLoesung.AfterLoadDFMValues;
    xdsTicketDateienDateiMime.AfterLoadDFMValues;
    xdsTicketDateienDateiName.AfterLoadDFMValues;
    xdsTicketDateienDateiGroesse.AfterLoadDFMValues;
    xdsTicketDateienDateiInhaltText.AfterLoadDFMValues;
    xdsticket2.AfterLoadDFMValues;
    xdsticket2Kundennummer.AfterLoadDFMValues;
    xdsticket2Produkt.AfterLoadDFMValues;
    xdsticket2Kategorie.AfterLoadDFMValues;
    xdsticket2Prioritaet.AfterLoadDFMValues;
    xdsticket2Status.AfterLoadDFMValues;
    xdsticket2ID.AfterLoadDFMValues;
    xdsticket2ErstelltAm.AfterLoadDFMValues;
    xdsticket2Betreff.AfterLoadDFMValues;
    xdsticket2Beschreibung.AfterLoadDFMValues;
    xdsticket2Abrechnungsbetrag.AfterLoadDFMValues;
    xdsticket2AbrechnungRechnungsnummer.AfterLoadDFMValues;
    xdsticket2AberechnetAm.AfterLoadDFMValues;
    xdsticket2ErledigtAm.AfterLoadDFMValues;
    xdsticket2Nachname.AfterLoadDFMValues;
    xdsticket2Vorname.AfterLoadDFMValues;
    xdsticket2Email.AfterLoadDFMValues;
    xdsticket2SystemInfo.AfterLoadDFMValues;
    xdsticket2Loesung.AfterLoadDFMValues;
    xdsticket2Protokoll.AfterLoadDFMValues;
    xdsticket2ZeitaufwandMinuten.AfterLoadDFMValues;
    xdsticket2AbzurechnendeMinuten.AfterLoadDFMValues;
    xdsticket2AbgerechneteMinuten.AfterLoadDFMValues;
    xdsticket2BenachrichtigungNEU.AfterLoadDFMValues;
    xdsticket2BenachrichtigungLoesung.AfterLoadDFMValues;
    xdsticket2InterneBemerkung.AfterLoadDFMValues;
    xdsticket2LoesungInfoSenden.AfterLoadDFMValues;
    xdsticket2Kontaktperson.AfterLoadDFMValues;
    xdsticket2KontaktpersonEmail.AfterLoadDFMValues;
    xdsticket2ErreichbarkeitTelefon.AfterLoadDFMValues;
    xdsticket2ErreichbarkeitWann.AfterLoadDFMValues;
  end;
end;

end.